import { render, staticRenderFns } from "./TheInscriptionTable.vue?vue&type=template&id=474e2da4&scoped=true"
import script from "./TheInscriptionTable.vue?vue&type=script&lang=js"
export * from "./TheInscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./TheInscriptionTable.vue?vue&type=style&index=0&id=474e2da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e2da4",
  null
  
)

export default component.exports